var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"mux-player full-width"},[_c('mux-player',_vm._b({key:_vm.playbackId,ref:"player",style:(_vm.style),attrs:{"accent-color":"var(--v-accentPurpleAccessible-base)"}},'mux-player',_vm.playerAttrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }